import { Intervention } from '../planning/intervention';
import { ELIMSData } from './elims-data';

export class ClientModel {

    public ELIMSData: ELIMSData;
    public InterventionList: Intervention[] = [];

    static mapFromJSON(json): ClientModel {
        const c = new ClientModel();

        c.ELIMSData = ELIMSData.mapFromJSON(json.elimsData);

        if (json.interventions) {
            c.InterventionList = json.interventions.map(jsonItem => Intervention.mapFromJSON(jsonItem));
        }

        return c;
    }
}
